import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

import {computed} from 'vue';
import dayjs, {Dayjs} from 'dayjs';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {DateRangeFieldType} from "@/components/business/crud/interface/FieldType";
import DateRangeTable from "@/components/business/crud/widgets/impl/DateRangeTable.vue";


import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: 'normal', show: 'small'},
});


export default /*#__PURE__*/_defineComponent({
  __name: 'DateRangeForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

const ranges = {
  一天: [dayjs().subtract(1, 'd'), dayjs()],
  一周: [dayjs().subtract(1, 'w'), dayjs()],
  一个月: [dayjs().subtract(1, 'month'), dayjs()],
}

const showTime = {
  hideDisabledOptions: true,
  defaultValue: [
    dayjs('00:00:00', 'HH:mm:ss'),
    dayjs('23:59:59', 'HH:mm:ss'),
  ],
}

const value = computed({
  get() {
    const param: Dayjs[] = [];
    if (data.value[props.widget.startPropName]) {
      param.push(dayjs(Number(data.value[props.widget.startPropName])));
    }
    if (data.value[props.widget.endPropName]) {
      param.push(dayjs(Number(data.value[props.widget.endPropName])));
    }
    return param;
  },
  set(value: Dayjs[]) {
    data.value[props.widget.startPropName] = value ? value[0]?.valueOf() : undefined;
    data.value[props.widget.endPropName] = value ? value[1]?.valueOf() : undefined;
  },
})


return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!

  return (_ctx.info.status === 'edit')
    ? (_openBlock(), _createBlock(_component_a_range_picker, {
        key: 0,
        style: {"width":"100%"},
        format: _ctx.widget.format,
        value: value.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        separator: "-",
        showTime: showTime,
        disabled: _ctx.info.status === 'show',
        allowClear: true,
        ranges: ranges,
        placeholder: [_ctx.info.title + '开始', _ctx.info.title + '结束']
      }, null, 8, ["format", "value", "disabled", "placeholder"]))
    : (_openBlock(), _createBlock(DateRangeTable, {
        key: 1,
        widget: _ctx.widget,
        data: _unref(data),
        "prop-name": _ctx.propName,
        info: _ctx.info
      }, null, 8, ["widget", "data", "prop-name", "info"]))
}
}

})